export * from './src/time-control/w-mat-timepicker/w-mat-timepicker.component';
export * from './src/time-control/w-time-dialog/w-time-dialog.component';
export * from './src/time-control/w-clock/w-clock.component';
export * from './src/time-control/w-time/w-time.component';
export * from './src/time-control/mat-timepicker/mat-timepicker.component';
export * from './src/time-control/mat-timepicker-toggle/mat-timepicker-toggle.component';

export { Angular5TimePickerModule } from './src/material-time-control.module';
export { TimepickerDirective } from './src/timepicker.directive';
